import styled from 'styled-components';
import media from '../../../../constants/media';
import { A } from '../../../base/typography';

export const Card = styled.div`
	display: flex;
	flex-flow: column;
	box-shadow: 0px 11px 24px #ececec;
	border: 1px solid #f1f1f1;
	${media.mobileAndTabletOnly`
		margin-bottom: 3rem;
	`}
	${media.desktopSmall`
		height: 100%;
	`}
`;

export const CardLink = styled(A)`
	height: 100%;
	display: flex;
	justify-content: space-between;
	padding: 3rem;
`;

export const Content = styled.div`
	display: flex;
	justify-content: space-between;
	width: 100%;
	${media.desktopSmall`
		flex-direction: column;
	`}
`;

export const Header = styled.div`
	display: flex;
	align-items: center;
	${media.desktopSmall`
		margin-bottom: 1rem;
	`}
`;

export const IconMobile = styled.div`
	display: flex;
	align-items: center;
	width: 4rem;
	margin-right: 2rem;
	${media.desktopSmall`
		display: none;
	`}
	svg {
		max-height: 4rem;
		max-width: 4rem;
		margin: 0;
	}
`;

export const Icon = styled.div`
	width: 4rem;
	margin-left: 2rem;
	${media.mobileAndTabletOnly`
		display: none;
	`}
	svg {
		max-height: 4rem;
		max-width: 4rem;
		margin: 0;
	}
`;

export const Info = styled.div`
	color: ${({ theme }) => theme.colors.gray};
	font-family: ${({ theme }) => theme.fonts.ArimoRegular};
	word-break: break-word;
	${media.mobileAndTabletOnly`
		display: none;
	`}
`;

export const Select = styled.div`
	display: flex;
	align-items: center;
	font-size: 2rem;

	svg {
		margin-right: 1rem;
		color: ${({ theme }) => theme.colors.gray};
	}
	p {
		text-decoration: underline;
		color: ${({ theme }) => theme.colors.primary};
		margin-bottom: 0;
	}

	${media.desktopSmall`
		font-size: 1.6rem;
    margin-top: 2rem;
	`}
`;
